
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fPK4h", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df41cc4d70a30093af7801a73c08281c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b86f5a9cb92196db$var$_react = $b86f5a9cb92196db$var$_interopRequireDefault((parcelRequire("42omo")));

var $b86f5a9cb92196db$var$_baseNew = $b86f5a9cb92196db$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b86f5a9cb92196db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircleUnchecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-circle-unchecked
 * Usage guidance:
 * Known uses: Incomplete items
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b86f5a9cb92196db$var$CheckCircleUncheckedIcon = (props)=>/*#__PURE__*/ $b86f5a9cb92196db$var$_react.default.createElement($b86f5a9cb92196db$var$_baseNew.default, Object.assign({
        name: "CheckCircleUncheckedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$b86f5a9cb92196db$var$CheckCircleUncheckedIcon.displayName = 'CheckCircleUncheckedIcon';
var $b86f5a9cb92196db$var$_default = module.exports.default = $b86f5a9cb92196db$var$CheckCircleUncheckedIcon;

});


//# sourceMappingURL=check-circle-unchecked.560799be.js.map
